import { useTranslation } from 'react-i18next';
import { SERVICE_AGREEMENT_NAMESPACE } from '../config/constants';

const useServiceAgreementTranslations = () => {
    return useTranslation(SERVICE_AGREEMENT_NAMESPACE);
};

export default useServiceAgreementTranslations;
